import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { Form, Input, Modal, Button, Icon } from 'semantic-ui-react'

class Editar extends Component{
	constructor(props){
		super(props)
		this.app= firebase;
		this.database = this.app.firestore().collection(this.props.tabla)
		this.state = {
			id: this.props.data.id,
			clave: this.props.data.clave,
			marca: this.props.data.marca,
			tipo: this.props.data.tipo,
			unidades: this.props.data.unidades,
			nombre: this.props.data.nombre,
			formula: this.props.data.formula || '',
		}
        this.useModal = false;
	}
	componentDidUpdate(prevProps, prevState) {
        if (this.state.nombre !== prevState.nombre || this.state.marca !== prevState.marca){
			const clave = `${this.state.nombre} @ ${this.state.marca}`
            this.setState({clave: clave})
        } 
    }
    changeUsModal=(e)=>{
		this.setState({useModal:e})
	}
    guardarDatos= async ()=>{
		console.log(this.state)
        const newdata = this.database.doc(this.state.id)
        try {
            newdata.update({
                clave: this.state.clave,
                marca: this.state.marca,
                tipo: this.state.tipo,
                unidades: this.state.unidades,
                nombre: this.state.nombre,
                formula: this.state.formula
            })
			alert("Datos Guardados Correctamente")
        } catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    editarProd =(e)=>{
		this.setState({[e.target.name]: e.target.value.toUpperCase()})
	}
	borrar= async (id)=>{
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
		this.changeUsModal(false)
	}
	render(){
		return (
		<>
			<button className='editar' onClick={() => this.changeUsModal(true)}><Icon name='edit' /></button>
			<Modal 
				onClose={() => this.changeUsModal(false)}
				onOpen={() => this.changeUsModal(true)}
				open={this.state.useModal}>
				<Modal.Header>
					Editar Producto: {this.state.clave} 
					<Button color='red' floated='right' onClick={
						() =>{
							const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${this.state.clave} ?`)
							if (confirmBox === true) {this.borrar(this.state.id)}
						  }
						}>Borrar Producto
					</Button>
				</Modal.Header>
				<Modal.Content>
				<Form>
					<Form.Field required>
						<label>Clave:</label> 
						<Input 
							name="clave"
							disabled
							value={this.state.clave}
							onChange={this.editarProd} 
						/>
					</Form.Field>
                    <Form.Field required>
						<label>Nombre:</label> 
						<Input 
							name="nombre"
							type='text'
							value={this.state.nombre}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
                    <Form.Field required>
						<label>Marca:</label> 
						<Input 
							name="marca"
							type='text'
							value={this.state.marca}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
					<Form.Field required>
						<label>Tipo:</label> 
						<Input 
							name="tipo"
							type='text'
							value={this.state.tipo}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
					<Form.Field required>
						<label>Unidades:</label> 
						<Input 
							name="unidades"
							type='text'
							value={this.state.unidades}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
					<Form.Field required>
						<label>Formula:</label> 
						<Input 
							name="formula"
                            type='text'
							value={this.state.formula}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
				</Form>
				</Modal.Content>
                <Modal.Actions>
                    <Button onClick={()=>this.guardarDatos()}>Guardar Cambios</Button>
				</Modal.Actions>
			</Modal>
		</>
		)
	}
}

export default Editar;